import(/* webpackMode: "eager", webpackExports: ["GoHomeBtn"] */ "/vercel/path0/app/[locale]/[...rest]/_component/GoHome.tsx");
